import myRequest from "./index";

// 获取urlscheme
export function getSchemeUrl({ scheme_id }) {
  return myRequest.post("/WechatApp/getSchemeUrl", { scheme_id });
}
